<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { applyThemeClasses } from '@/utils/themeColors'


const dots = ref('')
const message = ref('Getting the birds cosy')
const tick = ref(0)

let interval

onMounted(() => {
  interval = setInterval(() => {
    dots.value = dots.value.length >= 3 ? '' : dots.value + '.'
    tick.value++
    
    if (tick.value < 3) {
      message.value = 'Giving them time alone'
    } else if (tick.value < 6) {
      message.value = 'Fluffing pillows'
    } else if (tick.value < 9) {
      message.value = 'AN EGG!'
    } else {
      message.value = 'Hatching Chick'
    }
  }, 400)
})

onBeforeUnmount(() => {
  clearInterval(interval)
})
</script>

<template>
  <div :class="`fixed inset-0 ${applyThemeClasses('components.modal.overlay')} flex items-center justify-center z-50 overflow-y-auto`">
    <div :class="`rounded-lg ${applyThemeClasses('components.modal.container')} w-full min-w-[350px] max-w-4xl mx-auto my-2`">
        <div class="flex items-center justify-center mb-4">
          <div class="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
        </div>
        <p :class="applyThemeClasses('text.primaryLow')">
          {{ message }}{{ dots }}
        </p>
      </div>
    </div>
  </template>